<div class="mydp clickable">
  <button data-oa-el-id="vqm6" tabindex="-1" class="selection-btn" (click)="onButtonClick()">{{ selectionDayTxt || text }}</button>

  @if (showSelector) {
    <div class="selector" [ngClass]="{ right: pullRight }">
      <table class="nav-header">
        <tr>
          <td class="headermonth">
            <span class="headerbtn headerbtn-prev" (click)="prevMonth()"><i class="icon icon-left">&nbsp;</i></span>
            <span>{{ formattedMonth }} {{ formattedYear }}</span>
            <span class="headerbtn headerbtn-next" (click)="nextMonth()"><i class="icon icon-right">&nbsp;</i></span>
          </td>
        </tr>
      </table>
      <div class="overlay-container">
        <table class="calendar">
          <thead>
            <tr>
              @for (day of weekdays; track day) {
                <th>
                  {{ day }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (week of weeks; track week) {
              <tr>
                @for (day of week.days; track day) {
                  <td [attr.id]="createCellId(day)"
                    [ngClass]="getCssClass(day)"
                    (click)="selectDay(day)"
                    (mouseover)="onMouseOver(day)"
                    (mouseout)="onMouseOut(day)">
                    <div class="dayOfMonth" [title]="day.title">{{ day.isCurrentMonth ? day.dayOfMonth : "" }}</div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        @if (loading) {
          <div class="overlay">
            <img src="{{ spinnerUrl }}" alt="" />
          </div>
        }
        <!-- <spinner *ngIf="loading" class="overlay"  messageRelativePosition="bottom"> </spinner> -->
      </div>
      @if (isAdmin && message) {
        <div>
          {{ message }}
        </div>
      }
    </div>
  }
</div>
